import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private Environment:'Local'|'Production'|'Stage' = "Production"; //Production,Stage,Local

  private EnvironmentObject = {
    "Local" : {
      apiUrl:'http://localhost:3000/'
      // apiUrl:'https://real-tires-train.loca.lt/'
      //  apiUrl:"http://192.168.248.157:3000/"
    },
    "Stage" : {
    // apiUrl:"http://13.234.47.193:3004"
      // apiUrl:location.origin
      apiUrl:"https://vinwaves.vintechin.com/"
    },
    "Production" : {  
      // apiUrl:"http://localhost:3001" 
      apiUrl:location.origin + "/"

    }
  }
  constructor() {

  }

  getBaseUrl(){
    return this.EnvironmentObject[this.Environment]['apiUrl']
    // return this.EnvironmentObject[this.Environment]['apiUrl']+'/'
  }
}
